import type {
  LngLatBoundsLike,
  MapRef,
} from "react-map-gl/dist/esm/exports-maplibre"

function sortLatLngToSWNE(latLngArray: number[][]): number[][] {
  if (latLngArray.length === 0) {
    return [] // Handle empty array
  }

  let minLat = latLngArray[0][0]
  let maxLat = latLngArray[0][0]
  let minLng = latLngArray[0][1]
  let maxLng = latLngArray[0][1]

  for (let i = 1; i < latLngArray.length; i++) {
    const [lat, lng] = latLngArray[i]
    minLat = Math.min(minLat, lat)
    maxLat = Math.max(maxLat, lat)
    minLng = Math.min(minLng, lng)
    maxLng = Math.max(maxLng, lng)
  }

  return [
    [minLat, minLng],
    [maxLat, maxLng],
  ]
}

export function fitBound(
  map: any | MapRef,
  bounds: number[][],
  padding:
    | number
    | {
        top: number
        right: number
        bottom: number
        left: number
      } = 70,
  animate = false
) {
  let paddingObj = padding as {
    top: number
    right: number
    bottom: number
    left: number
  }

  if (typeof padding === "number") {
    paddingObj = {
      top: padding,
      right: padding,
      bottom: padding,
      left: padding,
    }
  }

  const libreMap = map as MapRef

  paddingObj.bottom = Math.max(80, paddingObj.bottom)
  paddingObj.top = Math.max(80, paddingObj.top)
  paddingObj.left = Math.max(40, paddingObj.left)
  paddingObj.right = Math.max(40, paddingObj.right)

  if (libreMap) {
    // swap lat and lng
    const newBounds = sortLatLngToSWNE(bounds).map((b) => [b[1], b[0]])

    libreMap.fitBounds(newBounds as LngLatBoundsLike, {
      padding: paddingObj,
      maxDuration: animate ? undefined : 500,
    })
  }
}

export function setPosition(
  marker: maplibregl.Marker | null,
  position:
    | {
        lat: number
        lng: number
      }
    | [number, number],
  mapType: "google" | "maplibre"
) {
  if (!marker) return

  if (mapType === "maplibre") {
    ;(marker as maplibregl.Marker).setLngLat([position[1], position[0]])
  } else {
  }
}
